import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import InsilicoCitations from "./components/citations/InsilicoCitations";
import MetaScores from "./components/MetaScores";
import { IndividualPredictions } from "./components/IndividualPredictions";
import {
  getDannDataIsAvailable,
  getDbnsfpDataIsAvailable,
  getIndividualDbs,
} from "./helpers/genericHelpers";
import { getInsilicoDbList } from "./helpers/getInSilicoDbList";
import { getNewInSilicoThresholds } from "../../../../../state/selectors/general.selectors";
import { getAllInsilcoData } from "./selectors/inSilicoPredictionScoresBased.selectors";
import InSilicoPredictionsScoresTable from "./components/InSilicoPredictionsScoresTable";
import withErrorGuard from "../../../../../HOC/withErrorGuard/withErrorGuard";
import ComponentPanel from "../../../../../components/atoms/ComponentPanel/ComponentPanel";

const InSilicoPredictionsScoresBased = ({ insilicoData, thresholds }) => {
  const insilicoDbs = useMemo(() => {
    if (insilicoData && thresholds) {
      return getInsilicoDbList(insilicoData, thresholds);
    }
    return [];
  }, [insilicoData, thresholds]);

  const isDannDataIsAvailable = getDannDataIsAvailable(insilicoDbs);
  const isDbnsfpDataIsAvailable = getDbnsfpDataIsAvailable(insilicoDbs);

  return (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          componentName="pathogenicity scores"
          title="In-Silico Predictors"
          content={
            <div className="varsome-inner-container">
              <MetaScores insilicoDbs={insilicoDbs} />
              <IndividualPredictions insilicoDbs={insilicoDbs} />
              <InSilicoPredictionsScoresTable
                insilicoDbs={getIndividualDbs(insilicoDbs).sort((a, b) =>
                  a.name.localeCompare(b.name)
                )}
              />
              {(isDannDataIsAvailable || isDbnsfpDataIsAvailable) && (
                <InsilicoCitations
                  isDannDataIsAvailable={isDannDataIsAvailable}
                  isDbnsfpDataIsAvailable={isDbnsfpDataIsAvailable}
                />
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  insilicoData: getAllInsilcoData(state),
  thresholds: getNewInSilicoThresholds(state),
});

InSilicoPredictionsScoresBased.propTypes = {
  insilicoData: PropTypes.shape({}),
  thresholds: PropTypes.arrayOf(PropTypes.shape({})),
};

InSilicoPredictionsScoresBased.defaultProps = {
  insilicoData: null,
  thresholds: [],
};

export default connect(mapStateToProps)(
  React.memo(
    withErrorGuard(
      InSilicoPredictionsScoresBased,
      "In-Silico Predictors",
      "In-Silico Predictors"
    )
  )
);
